import { Decoder, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../../Resource/Decoders';
import { TermsAndConditions, TermsAndConditionsResource } from './Types';

const termsDecoder: Decoder<TermsAndConditions> = succeed({});

export const termsResourceDecoder: Decoder<TermsAndConditionsResource> =
  resourceDecoder(termsDecoder);
